module.exports = __webpack_public_path__ + "static/img/5971_phase_function_Paper_Points.2f2e556.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5971_phase_function_Paper_Points.png
// module id = TmbK
// module chunks = 0